import { render, staticRenderFns } from "./SimpleFeeTable.vue?vue&type=template&id=0eb7df60"
import script from "./SimpleFeeTable.vue?vue&type=script&lang=ts"
export * from "./SimpleFeeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports